import type { createDefinitionLoader } from './load-definition'

export interface PanelController extends ReturnType<typeof createDefinitionLoader> {
  panel: HTMLDivElement
  scope: Element
  closeButton: HTMLButtonElement | null
  trigger: HTMLButtonElement | null
}

export const handleGlossaryClick = (event: Event, controller: PanelController) => {
  const { panel, scope, load } = controller
  if (event.defaultPrevented || !(event.target instanceof Element)) {
    return
  }
  if (
    event instanceof MouseEvent &&
    (event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey)
  ) {
    return
  }
  if (event.target.closest('[data-glossary-retry]') && controller.trigger) {
    void load(controller.trigger)
    return
  }
  const button = event.target.closest<HTMLButtonElement>('button[data-glossary]')
  if (!button || button.closest('[data-glossary-scope]') !== scope) {
    return
  }
  event.preventDefault()
  if (controller.trigger === button && panel.matches(':popover-open')) {
    panel.hidePopover()
    return
  }
  controller.trigger?.removeAttribute('aria-expanded')
  controller.trigger?.removeAttribute('aria-controls')
  controller.trigger = button
  button.setAttribute('aria-expanded', 'true')
  button.setAttribute('aria-controls', panel.id)
  void load(button)
  panel.showPopover()
  controller.closeButton?.focus({ preventScroll: true })
}

export const handleGlossaryToggle = (event: Event, { panel, trigger, abort }: PanelController) => {
  if ((event as ToggleEvent).newState !== 'closed') {
    return
  }
  abort()
  trigger?.setAttribute('aria-expanded', 'false')
  // Keep an outside click's new focus; restore it for Close/Escape.
  if (panel.contains(document.activeElement) || document.activeElement === document.body) {
    trigger?.focus({ preventScroll: true })
  }
}
